import JobDetailsProvider from './JobDetailsProvider'

export {
    useJobDetails,
    useJobDetailsEId,
} from './jobDetailsHooks'

export type {
    JobDetailsProviderContextValue,
} from './JobDetailsProvider'

export default JobDetailsProvider
